import DoneAllIcon from "@mui/icons-material/DoneAll";
import ErrorIcon from "@mui/icons-material/Error";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import { CircularProgress } from "@mui/material";
import type { BrowserSessionStatus } from "../types/browser-session";
import { StatusChip, type StatusEntry } from "./ui/status-chip";

const STATUS_MAP: Partial<Record<BrowserSessionStatus | "idle", StatusEntry>> = {
  starting: {
    icon: <CircularProgress size={12} color="inherit" />,
    color: "primary",
  },
  active: {
    icon: <CircularProgress size={12} color="inherit" />,
    color: "success",
  },
  closing: {
    icon: <PauseCircleIcon sx={{ fontSize: 12 }} />,
    color: "warning",
  },
  closed: { icon: <DoneAllIcon sx={{ fontSize: 12 }} />, color: "success" },
  error: { icon: <ErrorIcon sx={{ fontSize: 12 }} />, color: "error" },
  idle: { icon: <PlayCircleIcon sx={{ fontSize: 12 }} />, color: "default" },
};

type Props = {
  status: BrowserSessionStatus;
  variant?: "outlined" | "filled";
  size?: "small" | "medium";
  label?: string;
};

export const BrowserSessionStatusChip: React.FC<Props> = ({
  status,
  variant = "outlined",
  size = "small",
  label,
}) => (
  <StatusChip status={status} statusMap={STATUS_MAP} variant={variant} size={size} label={label} />
);
